import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe mis à jour");
      nav("/login");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Erreur");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--sand)" }}>
      <div className="w-full max-w-md card-warm p-8">
        <h1 className="font-serif-display text-3xl font-semibold" style={{ color: "var(--pine)" }}>Nouveau mot de passe</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input required type="password" placeholder="Nouveau mot de passe" className="input-field" value={password}
            onChange={e => setPassword(e.target.value)} data-testid="reset-password" />
          {err && <div className="text-red-600 text-sm">{err}</div>}
          <button className="btn-primary w-full justify-center" data-testid="reset-submit">Valider</button>
        </form>
        <div className="mt-4"><Link to="/login" className="text-sm text-[var(--forest)] hover:underline">← Retour à la connexion</Link></div>
      </div>
    </div>
  );
}
